export class CommunitiesDto {
  id: string;
  SiteId: string;
  ModifiedById: string;
  CreatedById: string;
  dateUpdated: Date;
  dateCreated: Date;
  SerialNo: Number;
  Version: Number;
  CommunityName: string;
  Abbreviation: string;
  LgaId: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  }
